export default __webpack_public_path__ + "static/media/sheet-metal-and-laser-cutting.7ba9de4b.png";